<template>
  <strong class="cmp-premium-badge ws-typography">
    <ws-icon name="favourite" :size="16" />
    <small v-if="!iconOnly" class="badge-label">
      <strong>{{ $t('general.premium') }}</strong>
    </small>
    <ws-tooltip>{{ $t('general.premium_tooltip') }}</ws-tooltip>
  </strong>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { WsIcon, WsTooltip } from '@loopia-group/components-vue2';

@Component({
  components: { WsIcon, WsTooltip },
})
export default class PremiumBadge extends Vue {
  @Prop(Boolean) readonly iconOnly!: boolean;
}
</script>

<style lang="scss" scoped>
.cmp-premium-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: $cart-item-premium-badge-bg;
  border-radius: $cart-item-premium-badge-radius;
  padding: map-get($space-xs, y) map-get($space-sm, x); // .badge-label has fixed 22px line-height, so have to decrease vertical padding to 2px

  .ws-icon,
  .badge-label {
    color: $cart-item-premium-badge-color;
  }

  .ws-icon {
    margin: auto 0;
  }

  .badge-label {
    margin: auto 0 auto map-get($space-sm, x);
    font-family: $ws-font-family-secondary;
    @include ws-typo-xs();
  }

  &.dark {
    background: $ws-base140;
    .ws-icon,
    .badge-label {
      color: $ws-white;
    }
  }
}
</style>
